import {
  ValidationSet,
  WithIncomeInterface
} from '../../../../types/interface';
import { commonValidations } from '../validations';

export const SubsidyWithIncomeValidationSet: ValidationSet<WithIncomeInterface> =
  {
    net_income: commonValidations.net_income,
    refund_percentage: commonValidations.refund_percentage,
    support_provided: commonValidations.support_provided,
    configuration_threshold_invoice: commonValidations.configuration_threshold_invoice,
    with_income_configuration_id: [],
    maximum_support_provided_per_child: [],
    maximum_support_provided_per_user_per_year: []
  };
